var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('../../src/js/vendor/slick.js');

function FourUpHero(el) {

  $(el).slick({
    speed: 800,
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: false,
    arrows: true,
    mobileFirst: true,
    slidesToShow: 2.3333,
    slidesToScroll: 1,
    prevArrow:'<span class="slick-prev"><i class="jp-icon-arrow-thin-left "></i></span>',
    nextArrow:'<span class="slick-next"><i class="jp-icon-arrow-thin-right"></i></span>',
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  $(window).on('resize orientationchange', function() {
    $(el).slick('resize');
  });
}

module.exports = FourUpHero;
